import { CalendarClock } from 'lucide-react'

import { Badge } from '@/frontend/components/ui/badge'

export function UpcomingBadge({
  size = 'sm',
}: {
  size?: React.ComponentPropsWithoutRef<typeof Badge>['size']
}) {
  return (
    <Badge variant="info" size={size} className="border-dashed">
      <CalendarClock />
      Upcoming
    </Badge>
  )
}
